<template>
  <div class="cert">
    <div class="cert-main">
      <Certification v-if="cert" :data="cert" />
    </div>
    <div class="cert-send" v-if="cert">
      <Card
        class="sert-send-info"
        title="电子证书须知">
        <ul style="line-height: 2;">
          <li>1、当前显示证书为您所获得的最高等级证书；</li>
          <li>2、具体证书等级以您所申请到的实体证书为准；</li>
          <li>3、若想换取实体证书，可联系野原之森官方微信客服换取；</li>
          <li>4、若您已获得Yesassess2级证书,并且满足获得1级证书的申请条件，您可以联系野原之森官方微信客服获得1级实体证书，但电子证书依然是2级证书</li>
          <li>5、每门课程仅可免费申请一次实体证书制证与寄送服务，如您需多次申请制证与寄送服务，可联系野原之森官方微信客服，将会酌情收取相应费用；</li>
          <li>6、证书制证到寄送需要30个工作日，申请后请耐心等待，寄送后我们将会通知您进行查收；</li>
          <li>7、更多证书与申请相关信息请联系野原之森官方微信客服，微信号：<span style="font-weight: bolder;">yeyuanzhisen</span></li>
        </ul>
      </Card>
      <!-- <Card
        class="sert-send-info"
        title="证书寄送信息">
        <ul class="info-list">
          <li class="list-item box-flex margin-bottom-10px">
            <span>收件人：</span>
            {{ cert.realName }}
          </li>
          <li class="list-item box-flex margin-bottom-10px">
            <span>联系号码：</span>
            {{ send.mobile }}
          </li>
          <li class="list-item box-flex margin-bottom-10px">
            <span>寄送地址：</span>
            {{ send.address || '暂未填写' }}
          </li>
          <li class="list-item box-flex margin-bottom-10px">
            <span>证件照：</span>
            <template v-if="!cert.diplomaPhoto">暂未上传</template>
            <div style="width: 100px;">
              <img :src="cert.diplomaPhoto | formatDiplomaPhoto">
            </div>
          </li>
          <template v-if="send.sendId">
            <li class="list-item box-flex margin-bottom-10px">
              <span>申请时间：</span>
              {{ send.createAt | formatDate }}
            </li>
            <li class="list-item box-flex margin-bottom-10px" v-if="send.hasSend">
              <span>寄送时间：</span>
              {{ send.sendTime | formatDate }}
            </li>
            <li class="list-item box-flex margin-bottom-10px">
              <span>寄送进度：</span>
              {{ send.hasSend ? '已寄出，请注意查收' : '正在制证，将会在30个工作日内为您寄送证书' }}
            </li>
            <li class="list-item box-flex margin-bottom-10px" v-if="send.hasSend">
              <span>承运快递：</span>
              {{ send.carrierCompany }}
            </li>
            <li class="list-item box-flex margin-bottom-10px" v-if="send.hasSend">
              <span>快递单号：</span>
              {{ send.waybillNo }}
            </li>
          </template>
          
        </ul>
        <Button
          v-if="!send.hasSend"
          type="warning"
          long
          @click="handleCompleteInfo">
          {{ !canApply ? '完善寄送信息' : '修改寄送信息' }}
        </Button>
        <Button
          v-if="canApply && !send.sendId"
          type="primary"
          long
          :loading="loading"
          class="margin-top-10px"
          @click="handleSendApply">申请寄送证书</Button>
      </Card> -->
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { CERTIFICATION } from '../../../libs/namespace'
import Certification from '../components/Certification'

export default {
  components: { Certification },
  data () {
    return {
      cert: null,
      loading: false
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    send () {
      return this.cert ? this.cert.sendInfo : {}
    },
    canApply () {
      return this.send.address && this.cert.diplomaPhoto
    }
  },
  handlers: {
    handleCompleteInfo () {
      this.openDialog({
        name: '/certification/dialogs/sendInfoEditor',
        data: {
          info: {
            sendAddress: this.cert.sendInfo.address,
            diplomaPhoto: this.cert.diplomaPhoto
          }
        },
        methods: {
          update: () => {
            this.fetchData()
          }
        }
      })
    },
    async handleSendApply () {
      const flag = await window.confirm({
        title: '是否确认申请证书寄送？',
        content: `
          <p class="text-paragraph text-bold text-orange">在您申请证书寄送后，我们将为您制证。制证周期为30个工作日。我们将会在30个工作日内为您寄出证书，您可以回到当前页面查看制证与寄送进度</p>
          <p class="text-paragraph">请确保您的寄送地址与证件照片符合以下要求：</p>
          <p class="text-bold text-indent">1、寄送地址填写明确，精确到门牌号</p>
          <p class="text-bold text-indent text-paragraph">2、证件照片为2寸清晰免冠蓝色背景电子照片</p>
          <p class="text-paragraph text-bold">如因不符合以上问题导致寄送出现错误，责任将由您自行承担</p>
          <p class="text-bold">您填写的当前寄送信息将会作为默认寄送信息，对之后的所有寄送申请生效。您可以在证书寄出之前或下次申请寄送时修改默认信息。新的信息对已经寄送的证书无效</p>
        `
      })
      if (!flag) return
      try {
        this.loading = true
        await this.certSendApply(this.cert.diplomaId)
        this.fetchData()
        window.toast.success('已收到您的寄送申请，请耐心等待寄送')
      } catch (error) {
        //
      } finally {
        this.loading = false
      }
    }
  },
  methods: {
    ...mapActions(CERTIFICATION, [ 'fetchCert', 'certSendApply' ]),

    async fetchData () {
      this.cert = await this.fetchCert(this.$route.params.courseId)
    }
  }
}
</script>

<style lang="less" scoped>
.cert {
  display: flex;
  justify-content: center;

  &-main {
    flex: none;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 80px;
  }
  &-send {
    flex: none;
    width: 400px;

    .info-list {
      .list-item {
        span {
          flex: none;
          width: 5em;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
